import { useContext } from "react";
import { useQuery } from "react-query";
import { AuthContext } from "../Context/AuthContext";

const UserDataFetcher = () => {
  const { user, token } = useContext(AuthContext);

  const { isLoading, isError, data: userData } = useQuery(
    ["userData", user?.userId, token],
    async () => {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/users/user/${user.userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch user data");
      }
      return response.json();
    },
    { enabled: !!token && !!user?.userId }
  );

  return { isLoading, isError, userData, adminData: userData };
};

export default UserDataFetcher;
